// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__tGp9-","balanceDisclaimer":"posDashboard_balanceDisclaimer__1XHiE"};